import axios from 'axios'
import Head from 'next/head'
import Link from 'next/link'
import Router from 'next/router'
import {useEffect,useState} from 'react'
import cookie from 'cookie'


import Header from '../components/Header'
import Breadcrumbs from '../components/Breadcrumbs'
import Container from '../components/Container'
import Auth from '../components/Auth'


import { Query } from 'react-apollo'

import { coursesAvailable } from '../gql/queries'
import {getCrumbs,GetCourse,GetCourseList,GetLesson} from "../components/dataParsers"

//const BACKEND_URL="http://localhost:3000"
import {BACKEND_URL} from "../config/config"
import StatusCard from '../components/StatusCard';




var Page = (props) => {
    var [token,setToken]=useState(props.token)
    var [loading,setLoading]=useState(false)
    var [errorAuth,setErrorAuth]=useState(false)
    
    var doAuth=async (login)=>{
        if (login){
            setLoading(true)
            var ref = await axios.get(BACKEND_URL+"/resolveLink?ref="+login).then(d=>d.data)
            .catch(function (error) {
                setLoading(false)
                setErrorAuth(true)
                if (error.response) {
                  // The request was made and the server responded with a status code
                  // that falls out of the range of 2xx
                  console.log(error.response.data);
                  console.log(error.response.status);
                  console.log(error.response.headers);
                } else if (error.request) {
                  // The request was made but no response was received
                  // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                  // http.ClientRequest in node.js
                  console.log(error.request);
                } else {
                  // Something happened in setting up the request that triggered an Error
                  console.log('Error', error.message);
                }
                console.log(error.config);
              });
            if (ref && !ref.error){
                console.log('REF OK',ref)
                document.cookie="ptq="+ref.token
                setToken(ref.token)
                document.location.href="/"
            }
            else {
                setErrorAuth(true)
                console.log(ref);
                
            }
            //setLoading(false)
        }
    }
    console.log({props,token})
    return (<div>
        <Header/>
        <Container>
        
        {(token)&&(<div>
            <Query query={coursesAvailable}>{({loading,error,data})=>{

                var result = null;    
                if (loading) result = <div>Подождите, идет загрузка данных...</div>
                else if (error||!data.coursesAvailable||data.coursesAvailable.length==0) {
                    console.log(error); 
                    if (data.coursesAvailable.length==0) return <div>Регистрация прошла успешно! Доступных курсов - нет. Напишите менеджеру, чтобы Вам был открыт доступ.</div>
                    else return <div><Auth errorAuth={errorAuth} loading={loading}  login={props.query.login} loginAction={()=>doAuth(props.query.login)}/></div>}
                else if (data) {
                    console.log('got data',data)
                    if (!props.query.course||props.query.course=='/') result = GetCourseList({data})
                    else if (props.query.lesson) result = GetLesson({data,currentCourse:props.query.course,currentLesson:props.query.lesson})
                    else  result = GetCourse({data,currentCourse:props.query.course})
                }  
                else (<div>Что-то пошло не так</div>)
    
                return <div>
                    <Breadcrumbs crumbs={getCrumbs(data,props.query.course,props.query.lesson)}/>
                    {result}
                </div>
            }}</Query></div>
        )}
        {(!token)&&(
            <Auth login={props.query.login} loading={loading}  errorAuth={errorAuth} loginAction={()=>doAuth(props.query.login)}/>
        )}

        
        
        </Container>
        
   
    </div>)
}
Page.getInitialProps=async ({req,query})=>{
    var cookies=req.headers.cookie?cookie.parse(req.headers.cookie):undefined
    var token = cookies?cookies.ptq:undefined;
    var setCookie=false;
    

    return {query,token}
   // return {query}
}

export default Page

